<template>
    <div class="p-3">
        <el-card header="Produtos cadastrados">

            <el-row class="py-2">
                <h5 class="v-col-6 v-col-md-9 me-3">Pesquisar</h5>
                <div class="v-col-6 v-col-md-3">
                    <el-radio-group v-model="searchType">
                        <el-radio value="string" border>por nome</el-radio>
                        <el-radio value="number" border>Pelo codigo</el-radio>
                    </el-radio-group>
                </div>
            </el-row>
            <ElRow class="pb-5" v-if="searchType == 'string'">
                <ElInput type="search" name="q" style="flex: 1" v-model="q" class="mx-1" placeholder="Procurar produtos" />
                <ElButton :loading="loading" @click="() => getProducts(q)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>
            <ElRow class="pb-5" v-else>
                <ElInput type="number" name="cod" v-model="cod" style="flex: 1" class="mx-1" placeholder="Digite o codigo do produto" />
                <ElButton :disabled="cod ? false:true" :loading="loading" @click="() => getProduct(cod)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>

            <PaginatedTable :loading="loading" :page="data.current_page" :show-rows="10" :pages="data.last_page" :data="data.data" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Preço', prop: 'price'},
                {label: 'Promocao', prop: 'promoction'},
                {label: 'Activo', prop: 'active'},
            ]" @change="changePage">
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/products/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                        <span class="p-2" v-if="data.row.active">
                            <el-button :loading="data.row.loading" @click="() => active(data.row)" type="warning" icon="RemoveFilled" title="Desativar"></el-button>
                        </span>
                        <span class="p-2" v-else>
                            <el-button :loading="data.row.loading" @click="() => active(data.row)" type="success" title="Activavar" icon="Select"></el-button>
                        </span>

                        <span class="p-2" v-if="!data.row.featured">
                            <el-button :loading="data.row.loading" @click="() => featured(data.row)" type="success" title="Destacar" icon="Upload"></el-button>
                        </span>
                        <span class="p-2" v-else>
                            <el-button :loading="data.row.loading" @click="() => featured(data.row)" type="warning" title="Despromover" icon="Download"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { Product } from '@/services/types/product';
import { defaultPaginated } from '@/utilities/helpers';

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Product>>(defaultPaginated)
    const q = ref<string>('')
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()

    const getProducts = async (q = '', page = 1) => {
        console.log("Okay")
        loading.value = true
        const res = await Api.get(`admin/products?q=${q}&page=${page}`)
        if (res.status == 200) {
            data.value = res.data.products
            console.log(res.data.products)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getProduct = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getProducts()
        } else {
            loading.value = true
            data.value.last_page = 1
            data.value.current_page = 1
            const res = await Api.get('admin/products/' + id)
            if (res.status == 200) {
                data.value.data = [res.data.product]
            } else {
                ElMessageBox.alert('Não foi encontrado nenhum produto com este código')
                data.value.data = []
            }
            loading.value = false
        }
    }

    const changePage = (page: number) => {
        getProducts(q.value, page)
    }

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/product/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }

    onBeforeMount(() => {
        getProducts()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getProducts()
        }
    })

    const active = async (row: any) => {
        row.loading = true
        const res = await Api.delete(`admin/products/${row.id}`)
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.active = !row.active
        }
        row.loading = false
    }
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
